import React, { Component } from 'reactn';
import { withRouter } from '../../../util/router-compatibility';
import { connect } from 'react-redux';

import { callDummyApi } from '../../../util/APIUtils';
import store, { currentUser, showHideLoader } from '../../core/store';
import { CustomIcons, icons } from '../../shared/components/custom-icons';
import { CustomTheme, Typography } from '@orijinworks/frontend-commons';

import { Box, withStyles, Grid } from '../../shared/components/MaterialUIComponents';

import withUnleash from '../../../v2/core/unleash/withUnleash';
import { UnleashService } from '../../../v2/services';
import UnleashProvider from '../../core/unleash/unleashProvider';
import { USER_CONTEXT } from '../../../constants';
import RenderTile from './render-tile';
import { hasRole, shouldShowMessagingItem } from '../../../v2/services/utilty';
import { canShowLocationManagement } from '../split-location-context';
import { ROLES } from '../../../constants';

const styles = (theme) => ({
  mainGrid: {
    minWidth: 240,
    [theme.breakpoints.down(1150)]: {
      width: '100%',
    },
    [theme.breakpoints.up(1500)]: {
      width: '33.3333%',
    },
    width: '50%',
  },
  iconSizes: {
    fill: CustomTheme.palette.purple.main,
    // `color` (not just `fill`) is needed for the MUI icons (manage_accounts/language) that
    // render their paths with `fill="currentColor"` rather than inheriting the SVG `fill` prop
    // the way the repo's own icon SVGs do.
    color: CustomTheme.palette.purple.main,
    width: '65px',
    height: '65px',
  },
  welcomeCard: {
    color: '#061E44',
  },
  zoomEffect: {
    transitionDelay: '600ms',
    height: '100%',
    display: 'block',
  },
  welcomeBox: {
    padding: '1rem 3rem',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  cardWrapper: {
    margin: '0rem 3rem',
  },
});

// MUI icon components (e.g. ManageAccountsIcon, LanguageIcon) size themselves via
// `.MuiSvgIcon-fontSizeMedium`'s `font-size` (width/height are 1em), which otherwise wins the
// cascade over the plain `width`/`height` in `iconSizes` and renders at MUI's default 24px.
// Inline `style` beats any class regardless of cascade order, so this goes on `style`.
const ICON_MUI_SIZE_OVERRIDE = { fontSize: '65px' };

//Class START //
class Home extends Component {
  state = {
    user: null,
  };

  introCards = [
    {
      cyprusId: 'user-management',
      name: 'Location & User Management',
      description: 'Manage features and permissions for user accounts and locations',
      url: '/manage',
      img: <CustomIcons icon={icons.LocationUserManagement} className={this.props.classes.iconSizes} />,
    },
    {
      cyprusId: 'location-module',
      name: 'Location Management',
      description: 'Manage settings for a location',
      url: '/location-management',
      // Only ever rendered once the split is on (canShowLocationManagement requires
      // splitEnabled), so it always gets Figma's `language` (globe) icon, node 236:2359.
      // MUI's own `.MuiSvgIcon-fontSizeMedium` rule (font-size, sizing via 1em) otherwise wins
      // the cascade over `iconSizes`' width/height, so the size has to go through `style`
      // (highest specificity) rather than `className` for MUI icons specifically.
      img: (
        <CustomIcons
          icon={icons.LocationManagementIcon}
          className={this.props.classes.iconSizes}
          style={ICON_MUI_SIZE_OVERRIDE}
        />
      ),
    },
    {
      cyprusId: 'pathways',
      name: 'Outcomes & Progress',
      description: 'Track and analyze the progress and time spent by learners',
      url: '/outcomes-and-progress',
      img: <CustomIcons icon={icons.Outcomes} className={this.props.classes.iconSizes} />,
    },
    {
      cyprusId: 'analytics',
      name: 'Analytics',
      description: 'Discover dashboards and get insights for facilities and learners from data',
      url: '/analytics',
      img: <CustomIcons icon={icons.Analytics} className={this.props.classes.iconSizes} />,
      hidden: false,
    },
    {
      cyprusId: 'messages', // UNDERLYING LOGIC EXIST ON THIS ID
      name: 'Messages',
      description: 'Communicate with learners and share important announcements to engage and motivate learners',
      url: '/messages',
      img: <CustomIcons icon={icons.Messages} className={this.props.classes.iconSizes} />,
      hidden: false,
      isMessagingCard: true, // Flag to identify messaging/feeds card
    },
    {
      cyprusId: 'voice-call', // UNDERLYING LOGIC EXIST ON THIS ID
      name: 'Voice Calls',
      description: 'Monitor and control voice call usage via auditing tools and contact management',
      url: '/voiceCalls',
      img: <CustomIcons icon={icons.VoiceCalls} className={this.props.classes.iconSizes} />,
      hidden: false,
      unleashFlagName: UnleashService.FLAGS.VOICE_CALL,
    },

    {
      cyprusId: 'Roles',
      name: 'Roles',
      description: 'Manage user roles and permissions',
      url: '/manageRoles',
      img: <CustomIcons icon={icons.Roles} className={this.props.classes.iconSizes} />,
      hidden: false,
    },
    {
      cyprusId: 'location-management',
      name: 'Location Management',
      description: 'Update and create locations and their settings',
      url: '/manageLocations',
      img: <CustomIcons icon={icons.Location} className={this.props.classes.iconSizes} />,
      hidden: false,
    },
  ];

  componentDidMount() {
    if (this.props.userDetail === null) {
      store.dispatch(this.qryuser());
    }
  }

  qryuser = () => {
    return async (dispatch, getState) => {
      try {
        dispatch(showHideLoader({ isLoading: true }));

        const data = await callDummyApi();
        dispatch(currentUser(data));
      } catch (error) {
        console.error('Failed to fetch user data:', error);
      } finally {
        dispatch(showHideLoader({ isLoading: false }));
      }
    };
  };

  render() {
    const { showMessageTile, showLocationSettingsTile, permissionLoadingStack, showVoiceCallTile } =
      this.global;
    const { classes, unleashProps } = this.props;
    
    // Get feature flags using unleash client
    const unleashClient = unleashProps.getClient();
    const disableV1Messaging = unleashClient.isEnabled(UnleashService.FLAGS.DISABLE_V1_MESSAGING);
    const enableFeeds = unleashClient.isEnabled(UnleashService.FLAGS.ENABLE_FEEDS);
    const splitLocationUserManagement = unleashClient.isEnabled(
      UnleashService.FLAGS.SPLIT_LOCATION_USER_MANAGEMENT
    );
    
    const Cards = this.introCards
      .filter((item) => permissionLoadingStack === 0)
      .filter((item) => {
        const isRouteAllowed = this.global.routes.findIndex((route) => route.path === item.url) !== -1;

        if (item.cyprusId === 'messages' && item.isMessagingCard) {
          // Show Feeds card if enableFeeds is true, otherwise show Messages card
          const path = enableFeeds ? '/feeds' : '/messages';
          return shouldShowMessagingItem(disableV1Messaging, enableFeeds, showMessageTile, isRouteAllowed, path);
        } else if (item.cyprusId === 'location-management') {
          // Legacy "Manage Locations" directory retires with the split; hide it once the flag is on.
          return isRouteAllowed && showLocationSettingsTile && this.global.isSuperAdmin && !splitLocationUserManagement;
        } else if (item.cyprusId === 'location-module') {
          return (
            canShowLocationManagement({
              splitEnabled: splitLocationUserManagement,
              isFacilityStaff: this.global.isTeacher || hasRole(this.global.roles, ROLES.FACILITY_STAFF),
              isAttorney: hasRole(this.global.roles, ROLES.ATTORNEY),
              isMessagingOnly: hasRole(this.global.roles, ROLES.MESSAGING_ONLY),
            }) && isRouteAllowed
          );
        } else if (item.cyprusId === 'Roles') {
          return this.global.isSuperAdmin;
        } else if (item.cyprusId === 'analytics') {
          return !unleashProps.isFlagEnabled();
        } else if (item.cyprusId === 'voice-call') {
          const isVoiceCallRoleAllowed =
            !hasRole(this.global.roles, ROLES.ATTORNEY) &&
            !hasRole(this.global.roles, ROLES.MESSAGING_ONLY);

          return isRouteAllowed && showVoiceCallTile && isVoiceCallRoleAllowed;
        }
        return isRouteAllowed;
      })
      .map((card) => {
        const { classes } = this.props;
        let { cyprusId, name, url, description, img, unleashFlagName, isMessagingCard } = card;
        
        // Transform Messages card to Feeds card when enableFeeds is true
        if (isMessagingCard && enableFeeds) {
          name = 'Feeds';
          url = '/feeds';
          description = 'Connect with and engage learners through announcements and one-to-one messages';
        }

        if (cyprusId === 'user-management' && splitLocationUserManagement) {
          name = 'User Management';
          url = '/user-management';
          description = 'Manage access for user accounts';
          // Figma split spec (node 236:2359) wants `manage_accounts`, not the legacy
          // combined-module globe this card falls back to when the split flag is off.
          img = (
            <CustomIcons
              icon={icons.UserManagementIcon}
              className={classes.iconSizes}
              style={ICON_MUI_SIZE_OVERRIDE}
              alt="User Management"
              title="User Management"
            />
          );
        }

        return unleashFlagName ? (
          <UnleashProvider key={cyprusId} flagName={unleashFlagName}>
            <RenderTile
              cyprusId={cyprusId}
              name={name}
              url={url}
              description={description}
              img={img}
              classes={classes}
            />
          </UnleashProvider>
        ) : (
          <RenderTile
            key={cyprusId}
            cyprusId={cyprusId}
            name={name}
            url={url}
            description={description}
            img={img}
            classes={classes}
          />
        );
      });
    return (
      <div>
        <Box className={classes.welcomeBox}>
          <Typography variant="h1" className={classes.welcomeCard} gutterBottom>
            Welcome, {USER_CONTEXT?.given_name || USER_CONTEXT?.preferred_username || ''}
          </Typography>
        </Box>

        <div className={classes.cardWrapper}>
          <Grid id="hero-grid" container spacing={3}>
            {Cards}
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state.currentUser;
};

export default connect(mapStateToProps)(
  withUnleash(withStyles(styles)(withRouter(Home)), UnleashService.FLAGS.SISENSE_DASHBOARD_SUBTAB)
);